import '../Model/Question';
import { StartEnd } from '../Model/StartEnd';
export class StartEndService {
    constructor(apiService) {
        this.apiService = apiService;
    }
    async saveStart() {
        const response = await this.apiService.get('start_service');
        if (!response.ok) {
            throw new Error(`Error al guardar el inicio.`);
        }
        return true;
    }
    async saveEnd() {
        const response = await this.apiService.get('end_service');
        if (!response.ok) {
            throw new Error(`Error al guardar el fin.`);
        }
        return true;
    }
    async find() {
        const response = await this.apiService.get('start-end');
        if (!response.ok) {
            throw new Error(`Error al obtener los parametros.`);
        }
        const content = await response.json();
        return content.map(startEnd => new StartEnd(startEnd).getState());
    }
}
